import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import kehilaMigrationWizardStore from 'store/kehilaMigrationWizard.store'
import { GridTable, IdLine, TextInput, MiniButton, Note } from '../KehilaMigrationWizard.styles'

const MapPermissionsStep: FC = () => {
  const store = kehilaMigrationWizardStore
  const { t } = useTranslation('kehilaMigration')

  if (store.loadingCategories) {
    return <Note>{t`map_loading`}</Note>
  }

  return (
    <>
      <GridTable>
        <thead>
          <tr>
            <th style={{ width: '55%' }}>{t`map_oldCategory`}</th>
            <th>{t`map_categoryManager`}</th>
            <th style={{ width: 70 }} />
          </tr>
        </thead>
        <tbody>
          {store.categories.map(category => (
            <tr key={category.oldCategoryId} className={category.skip ? 'off' : ''}>
              <td>
                {category.categoryName}
                <IdLine> · {t`map_id`} {category.oldCategoryId}</IdLine>
              </td>
              <td>
                <TextInput value='1' disabled style={{ width: 80 }} />
              </td>
              <td>
                <MiniButton onClick={() => store.toggleSkip(category.oldCategoryId)}>
                  {category.skip ? t`map_keep` : t`map_skip`}
                </MiniButton>
              </td>
            </tr>
          ))}
        </tbody>
      </GridTable>
      <Note style={{ display: 'block', marginTop: 12 }}>
{t('map_categoriesToCreate', { num: store.liveCategories.length })}
      </Note>
    </>
  )
}

export default observer(MapPermissionsStep)
